module.exports = __webpack_public_path__ + "static/media/top2_off.5f01940f.png";